<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="applCatText"
    item-value="applCatCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MmmmApplCatInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0438')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  methods: {
    onChange(value) {
      const select = this.items.find((v) => v.applCatCd == value)
      if (select != undefined) {
        this.$emit('inputModel', select)
      } else {
        this.$emit('inputModel', null)
      }
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
      }

      const elements = await API.get('/master/mmmm/applCats', params)
      elements.forEach((element) => {
        element['applCatText'] = element['applCatCd'] + ' : ' + element['applCatName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0438') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
